import { render } from "./SessionTypeChip.vue?vue&type=template&id=0ce3ef57"
import script from "./SessionTypeChip.vue?vue&type=script&lang=js"
export * from "./SessionTypeChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__